import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Icon } from '@iconify/react';

export default function PhotoPaymentPopup({
  show,
  onClose,
  userCoins,
  requiredCoins,
  selectedCharacterStyle,
  setSelectedCharacterStyle,
  isGenerating,
  onGenerateWithCoins,
  onKakaoPay,
}) {
  const canGenerate = Number(userCoins) >= Number(requiredCoins);

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          className="photo-payment-popup-overlay"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          onClick={onClose}
        >
          <motion.div
            className="photo-payment-popup"
            initial={{ scale: 0.9, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            exit={{ scale: 0.9, opacity: 0 }}
            onClick={(e) => e.stopPropagation()}
          >
            <div className="photo-payment-popup-header">
              <div className="photo-payment-popup-title-wrapper">
                <h3 className="photo-payment-popup-title">결제</h3>
                <span className="photo-payment-popup-coins">보유 코인: {userCoins}coin</span>
              </div>
              <button className="photo-payment-popup-close" onClick={onClose}>
                <Icon icon="solar:close-circle-bold" width={20} height={20} />
              </button>
            </div>

            <div className="photo-payment-popup-content">
              <div className="photo-payment-section">
                <h4 className="photo-payment-section-title">캐릭터 스타일 선택</h4>
                <div className="photo-payment-style-grid">
                  <button
                    className={`photo-payment-style-btn ${selectedCharacterStyle === 'cartoon' ? 'active' : ''}`}
                    onClick={() => setSelectedCharacterStyle('cartoon')}
                  >
                    <span className="style-emoji">🎨</span>
                    <span>카툰 스타일</span>
                    {selectedCharacterStyle === 'cartoon' && (
                      <div className="checkmark">
                        <Icon icon="solar:check-circle-bold" width={16} height={16} />
                      </div>
                    )}
                  </button>
                  <button
                    className={`photo-payment-style-btn ${selectedCharacterStyle === 'real' ? 'active' : ''}`}
                    onClick={() => setSelectedCharacterStyle('real')}
                  >
                    <span className="style-emoji">📷</span>
                    <span>리얼 사진 스타일</span>
                    {selectedCharacterStyle === 'real' && (
                      <div className="checkmark">
                        <Icon icon="solar:check-circle-bold" width={16} height={16} />
                      </div>
                    )}
                  </button>
                </div>
              </div>

              <div className="photo-payment-section">
                <h4 className="photo-payment-section-title">구매 정보</h4>
                <div className="photo-payment-info">
                  <div className="photo-payment-info-item">
                    <span className="info-label">이미지 1장 생성시</span>
                    <span className="info-value">{requiredCoins}coin 소모</span>
                  </div>
                  <div className="photo-payment-info-item">
                    <span className="info-label">10 coin 구매</span>
                    <span className="info-value">1,000원</span>
                  </div>
                  <div className="photo-payment-info-item highlight">
                    <span className="info-label">첫 구매시</span>
                    <span className="info-value">3coin 추가 증정</span>
                  </div>
                </div>
              </div>

              {canGenerate ? (
                <button
                  className="photo-generate-btn"
                  onClick={onGenerateWithCoins}
                  disabled={isGenerating || !selectedCharacterStyle}
                  style={{ marginTop: 12 }}
                >
                  <div className="photo-generate-btn-content">
                    {isGenerating ? (
                      <>
                        <Icon icon="solar:magic-stick-3-bold" className="generate-icon" width={20} height={20} />
                        생성 중...
                      </>
                    ) : (
                      <>
                        <Icon icon="solar:magic-stick-3-bold" width={20} height={20} />
                        생성하기
                      </>
                    )}
                    <span className="photo-generate-subtitle">
                      이미지 1장 생성 시 {requiredCoins}coin이 소모됩니다
                    </span>
                  </div>
                </button>
              ) : (
                <button className="photo-payment-kakao-btn" onClick={onKakaoPay} disabled={!selectedCharacterStyle}>
                  카카오 페이 결제하기
                </button>
              )}
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}


